import { Component, OnInit } from '@angular/core';
import { BaseView } from './BaseViewUI/BaseView';
import {BaseViewUI} from './BaseViewUI/BaseViewUI';

/**
 * BasePopoverContentsComponent
 *
 * ポップアップの中身用ベースクラス
 */
 @Component({
	template: ''
})
export abstract class BasePopoverContentsComponent extends BaseViewUI implements OnInit {

	/**
	 * 初期化処理
	 */
	constructor() {
		super();
	}

	/**
	 * ngOnInit
	 * start()を実行する。
	 * HACK: IonPopoverを使うと、start() を呼ぶタイミングがないので、これで呼び出す。
	 */
	ngOnInit(): void {

		// BaseViewで強制してるので、継承しているクラスで実装しているはず。
		// 継承側の実装されてる処理が動作する。
		this.start();

	}


}
